module.exports = __webpack_public_path__ + "img/SHACMAN.ac3120f6.svg";